const echarts = require("echarts");

export default function (data) {
  return {
    grid: {
      top: "10",
      left: "10",
      right: "10",
      bottom: "10",
      containLabel: true,
    },
    legend: {
      x: "right",
      y: "top",
      show: true,
      type: "scroll",
      // itemWidth: 10,
      // itemHeight: 10,
      itemGap: 20,
      data: ["用水", "用电"],
      textStyle: {
        fontSize: 12,
        color: "#fff",
        fontFamily: "Microsoft YaHei",
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true,
      },
      splitLine: {
        show: false,
      },
      nameTextStyle: {
        color: "#fff",
      },
      axisLabel: {
        color: "#fff",
      },
      axisTick: {
        show: false, //隐藏x轴刻度
      },
      data: ["01月", "02月", "03月", "04月", "05月"],
    },
    yAxis: {
      type: "value",
      axisTick: {
        alignWithLabel: true,
      },
      splitLine: {
        show: false,
      },
      nameTextStyle: {
        color: "#fff",
      },
      axisLabel: {
        color: "#fff",
      },
      axisTick: {
        show: false, //隐藏x轴刻度
      },
    },
    series: [
      {
        name: "用水",
        data: [350, 209, 107, 170, 70],
        type: "line",
        smooth: false,
        itemStyle: {
          normal: {
            color: "#A2FFFF",
            borderColor: "#A2FFFF",
          },
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(101, 251, 248)",
            },
            {
              offset: 1,
              color: "rgb(19, 33, 52)",
            },
          ]),
        },
      },
      {
        name: "用电",
        data: [250, 109, 110, 99, 69],
        type: "line",
        smooth: false,
        itemStyle: {
          normal: {
            color: "#F9F262",
            borderColor: "#F9F262",
          },
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(249, 242, 98)",
            },
            {
              offset: 1,
              color: "rgb(19, 33, 52)",
            },
          ]),
        },
      },
    ],
  };
}
